import { Col, Form, type FormInstance, Row } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import { Container } from '@/components/Container';
import { TableGrade } from '../../../components/table-grade/TableGrade';

export function ProdutoTabVariacaoGrade({
    form,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    setFormDirty: (dirty: boolean) => void;
}) {
    const variacao = Form.useWatch('variacao', form);

    const numeroGrades = variacao?.grade?.filter((g) => g.excluir !== 'S').length || 0;

    return (
        <Container title={`Grade das variações (${numeroGrades})`}>
            <Row gutter={[8, 8]}>
                <Col lg={16} md={24} sm={24} xl={12} xs={24}>
                    <TableGrade
                        onChange={(value) => {
                            const estoqueTotal = (value.grade ?? [])
                                .filter((grade) => grade.excluir !== 'S')
                                .reduce((total, grade) => total + (grade.estoque_total ?? 0), 0);

                            form.setFieldsValue({
                                estoque_total: estoqueTotal,
                                variacao: value,
                            });
                            setFormDirty(true);
                        }}
                        value={variacao}
                    />
                </Col>
            </Row>
        </Container>
    );
}
